"use client";
import React from "react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ReactSVG } from "react-svg";

import "./Testimonials.scss";
import TestimonialCard from "@/components/TestimonialCard/TestimonialCard";
import { motion } from "framer-motion";
import { fadeIn, defaultViewport } from "@/utils/animations";
import { ReUsableSwiper } from "@webelocity/ui";
import { ReviewEntry } from "@/lib/strapi/types";

interface TestimonialsClientProps {
  reviews: ReviewEntry[];
  averageRating: number | null;
}

const TestimonialsClient: React.FC<TestimonialsClientProps> = ({
  reviews,
  averageRating,
}) => {
  return (
    <div className="home-testimonials-wrapper baseContainer">
      <div className="section-wrap maxWidth">
        <motion.div
          className="header-wrapper"
          variants={fadeIn}
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
        >
          <p className="section-main-header">Hear from Our Happy Customers</p>

          <div className="right-wrapper">
            {averageRating !== null && (
              <div className="row">
                <ReactSVG
                  src={"/assets/blue-star-ic.svg"}
                  width={36}
                  height={36}
                />
                <p className="section-main-header blue-500">{averageRating}</p>
              </div>
            )}
          </div>
        </motion.div>

        <ReUsableSwiper
          data={reviews}
          renderSlide={(item) => (
            <TestimonialCard
              key={item.id}
              name={item.name}
              image={item.image}
              rate={item.rating}
              testimonial={item.description}
            />
          )}
          swiperOptions={{
            slidesPerView: 1,
            breakpoints: {
              768: { slidesPerView: 2 },
              1300: { slidesPerView: 3 },
            },
            spaceBetween: 16,
          }}
          className="testimonials-swipper-wrapper"
          slideStyles="!h-auto"
        />
      </div>
    </div>
  );
};

export default TestimonialsClient;
